module.exports = __webpack_public_path__ + "img/41.e765c2a9.png";